/**
 * Время в сообщениях о связи — одна утилита на приложение (RP-UI-LINK), в часовом поясе устройства. Поведение совместимо с
 * прежними копиями (`clock`/`clockOf`/`momentText`), которые шаги 3–6 удаляют: часы «ЧЧ:ММ», день — «сегодня в» /
 * «вчера в» / «ДД.ММ в». Часы собираются вручную, а не `toLocaleTimeString`: так строка не зависит от ICU браузера.
 */

const DAY_MS = 24 * 60 * 60 * 1000

/** Момент из ISO-строки, мс или `Date`; `null` — пусто или не разбирается. */
function momentOf(value: string | number | Date | null | undefined): Date | null {
  if (value === null || value === undefined || value === '') return null
  const moment = value instanceof Date ? new Date(value.getTime()) : new Date(value)
  return Number.isNaN(moment.getTime()) ? null : moment
}

const two = (value: number) => String(value).padStart(2, '0')

/** «12:57» в поясе устройства; `null` — момента нет или он не разбирается. */
export function formatClock(value: string | number | Date | null | undefined): string | null {
  const moment = momentOf(value)
  return moment === null ? null : `${two(moment.getHours())}:${two(moment.getMinutes())}`
}

/**
 * Момент словами: «сегодня в 12:57», «вчера в 21:03», «20.10 в 14:32». «Сегодня» — с полуночи устройства (будущее
 * время тоже «сегодня», как у прежней `momentText`); `null` — момента нет.
 */
export function formatMoment(value: string | number | Date | null | undefined, now: Date = new Date()): string | null {
  const moment = momentOf(value)
  if (moment === null) return null
  const at = `${two(moment.getHours())}:${two(moment.getMinutes())}`
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
  if (moment.getTime() >= startOfToday) return `сегодня в ${at}`
  if (moment.getTime() >= startOfToday - DAY_MS) return `вчера в ${at}`
  return `${two(moment.getDate())}.${two(moment.getMonth() + 1)} в ${at}`
}

/**
 * Промежуток словами для счётчиков связи: «12 с», «1 мин 05 с», «2 ч 03 мин». Целые секунды, вниз; отрицательный (часы устройства
 * ушли назад) читается как ноль.
 */
export function formatSpan(ms: number): string {
  const whole = Math.max(0, Math.floor(ms / 1000))
  if (whole < 60) return `${whole} с`
  const minutes = Math.floor(whole / 60)
  if (minutes < 60) return `${minutes} мин ${two(whole % 60)} с`
  return `${Math.floor(minutes / 60)} ч ${two(minutes % 60)} мин`
}
